import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
export const FAQ = () => {
  return <section className="mb-10" data-id="element-171">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-172">
        Veelgestelde vragen
      </h2>

      <div className="space-y-6" data-id="element-173">
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-174">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-175">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-176" />
            <h3 className="font-bold" data-id="element-177">
              Is deze cursus geschikt voor een puppy?
            </h3>
          </div>
          <div className="p-4" data-id="element-178">
            <p className="leading-relaxed" data-id="element-179">
              Jazeker! Juist voor een puppy is dit aan te raden. Door vanaf het
              begin te leren communiceren in hondentaal, voorkom je veel
              problemen later.
            </p>
          </div>
        </div>

        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-180">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-181">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-182" />
            <h3 className="font-bold" data-id="element-183">
              Mijn hond is angstig of onzeker. Is deze cursus geschikt?
            </h3>
          </div>
          <div className="p-4" data-id="element-184">
            <p className="leading-relaxed" data-id="element-185">
              Absoluut, juist dan! De cursus geeft je handvatten om je angstige
              hond te helpen zich veilig te voelen. Je leert hoe je rust en
              vertrouwen kunt geven op een manier die je hond daadwerkelijk
              begrijpt.
            </p>
          </div>
        </div>

        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-186">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-187">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-188" />
            <h3 className="font-bold" data-id="element-189">
              Werkt dit ook voor honden met een 'rugzakje'?
            </h3>
          </div>
          <div className="p-4" data-id="element-190">
            <p className="leading-relaxed" data-id="element-191">
              Ja. Veel adoptiehonden uit asiels of het buitenland hebben extra
              baat bij deze aanpak. Ze hebben vaak geleerd om mensen te
              wantrouwen. Door te communiceren in hun eigen taal, kun je dat
              vertrouwen opbouwen.
            </p>
          </div>
        </div>

        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-192">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-193">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-194" />
            <h3 className="font-bold" data-id="element-195">
              Kan ik de cursus op mijn eigen tempo volgen?
            </h3>
          </div>
          <div className="p-4" data-id="element-196">
            <p className="leading-relaxed" data-id="element-197">
              Ja, je hebt levenslange toegang. Je kunt de lessen bekijken
              wanneer het jou uitkomt, zo vaak als je wilt, en in je eigen
              tempo.
            </p>
          </div>
        </div>

        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-198">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-199">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-200" />
            <h3 className="font-bold" data-id="element-201">
              Wat als ik vragen heb tijdens de cursus?
            </h3>
          </div>
          <div className="p-4" data-id="element-202">
            <p className="leading-relaxed" data-id="element-203">
              Je kunt altijd contact opnemen via info@stresslessdogs.nl. We
              helpen je graag verder.
            </p>
          </div>
        </div>
      </div>
    </section>;
};